module.exports = __webpack_public_path__ + "e1d9194473db10d22f0081c0dc2e4b08.jpg";